import Grid from "@mui/material/Grid";
import React from "react";

import { MttAnalyticsPage } from "./mtt-analytics-page";

const MttAnalyticsModule: React.FC = () => {
  return (
    <Grid container rowSpacing={2} columnSpacing={2} sx={{ position: "relative" }}>
      <Grid size={{ xs: 12, md: 12 }}>
        <MttAnalyticsPage />
      </Grid>
    </Grid>
  );
};

export default MttAnalyticsModule;
